import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() =>
    ({
        container: {
            margin: 24
        }
    })
)


const PageLayout: React.FC = ({ children }) => {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            {children}
        </div>
    )
}

export default PageLayout
